import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import {
  ADDRESS_GET_API,
  ADDRESS_SAVE_API,
  ADDRESS_SELECTED_API,
  ADDRESS_UPDATE_API,
  AREA_API,
  CITY_API,
  DELIVERY_OPTIONS_API,
  PLACE_ORDER_POST_API,
  PROVINCE_API,
  SELECT_DELIVERY_OPTION_API,
} from "../app/constants";
import { BASE_URL } from "..";
import BtnLoader from "./BtnLoader";
import { Controller, useForm } from "react-hook-form";
import Notification from "../helper/Notification";

const Checkout = () => {
  const token = localStorage.getItem("accessToken");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [select, setSelect] = useState(true);

  const [data, setData] = useState([]);
  const fetchAllData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}${ADDRESS_GET_API}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200 && response.data.code === 1) {
        setData(response.data.data);
      } else {
        throw new Error(
          response.data.message || "Failed to fetch address data."
        );
      }
    } catch (error) {
      // Handle errors
      console.error("Error fetching address data:", error);
    }
  };
  //
  const types = [
    { name: "Home", value: true },
    { name: "Office", value: false },
  ];

  useEffect(() => {
    axios
      .get(`${BASE_URL}${PROVINCE_API}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setProvinces(response.data.data);
      })
      .catch((error) => console.error("Error fetching provinces:", error));
  }, [token]);

  useEffect(() => {
    if (!isLoading) {
      axios
        .get(`${BASE_URL}${ADDRESS_GET_API}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          setAddressData(response.data.data);
          const fetchedData = response.data.data;
          console.log({ fetchedData });

          const defaultAddress = fetchedData.find(
            (item) => item.isDefault === true
          );

          if (defaultAddress) {
            setSelectedId(defaultAddress); // Set the default address object
          } else {
            setSelectedId(null); // Explicitly set to null if no default address
          }
        })
        .catch((error) => console.error("Error fetching cities:", error));
    }
  }, [BASE_URL, ADDRESS_GET_API, token, isLoading]);
  const [selectedId, setSelectedId] = useState(null);

  const handleOpenDrawer = () => {
    fetchAllData();
    setIsDrawerOpen(!isDrawerOpen);
  };

  const [paymentMethods, setPaymentMethods] = useState([]);
  const [error, setError] = useState("");
  const [selectedMethod, setSelectedMethod] = useState(null);

  const [charges, setCharges] = useState(null); // Charges state

  // Fetch payment methods (This is already done)
  useEffect(() => {
    const fetchPaymentMethods = async () => {
      try {
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) throw new Error("Access token not found.");

        const response = await axios.get(`${BASE_URL}${DELIVERY_OPTIONS_API}`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });

        if (response.status === 200 && response.data.code === 1) {
          const defaultOptionId = response.data.data[0].id;
          localStorage.setItem("defaultOptionId", defaultOptionId);

          const fetchedData = response.data.data.map((item) => ({
            id: item.id,
            method: item.label,
            icon: "bi bi-truck",
            iconColor: "#2ecc71",
            infoDetails: {
              point1: item.description,
              point2: `Charges: Rs. ${item.charges}`,
              point3: `Delivery Time: ${item.deliveryTime}`,
              point4: item.active
                ? "This option is currently available."
                : "This option is currently unavailable.",
            },
          }));

          setPaymentMethods(fetchedData);
          setSelectedMethod(fetchedData[0]);

          // Fetch charges for the default payment method
          fetchSelectedOption(defaultOptionId); // Calling the function to set the charges initially
        } else {
          throw new Error(response.data.message || "Failed to fetch data.");
        }
      } catch (error) {
        setError(error.message || "Error fetching payment methods.");
        console.error(error);
      }
    };

    fetchPaymentMethods();
  }, []);

  // Fetch charges for selected payment option (using the default option initially)
  const fetchSelectedOption = async (id) => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      if (!accessToken) throw new Error("Access token not found.");

      const response = await axios.get(
        `${BASE_URL}${SELECT_DELIVERY_OPTION_API}${id}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      if (response.status === 200 && response.data.code === 1) {
        setCharges(response.data.data.charges); // Update charges state
      } else {
        throw new Error(response.data.message || "Failed to fetch data.");
      }
    } catch (error) {
      setError(error.message || "Error fetching charges.");
    }
  };

  // Handle tab click (selecting a different payment option)
  const handleTabClick = (method) => {
    setSelectedMethod(method);
  };
  const postplaceOrder = async () => {
    const payload = {
      shippingAddress:
        selectedId.name +
        ", " +
        "+92" +
        selectedId.phone +
        ", " +
        (selectedId?.isHomeAddress ? "home" : "office") + // Conditional check for HomeAddress
        ", " +
        selectedId?.detailAddress +
        ", " +
        selectedId?.city +
        ", " +
        selectedId?.province,
      shippingOption: selectedMethod.id,
    };

    try {
      const response = await axios.post(
        `${BASE_URL}${PLACE_ORDER_POST_API}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 && response.data.code === 1) {
        const orderId = response.data.data.orderId;
        sessionStorage.setItem("orderId", orderId);
      } else {
        throw new Error(response.data.message || "Failed to fetch data.");
      }
    } catch (error) {
      setError(error.message || "Error fetching charges.");
    }
  };

  // address apis common apis is here

  const [isFormVisible, setIsFormVisible] = useState(false);
  const [currentAddressId, setCurrentAddressId] = useState(null);
  const [currentBtn, setCurrentBtn] = useState(false);

  const [newAddress, setNewAddress] = useState({
    type: "Home",
    fullName: "",
    phone: "",
    buildingHouseNo: "",
    fullAddress: "",
    area: "",
    colony: "",
    city: "",
    province: "",
    country: "",
    postCode: "",
  });

  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [areas, setAreas] = useState([]);

  const [isMessage, setIsMessage] = useState(null); // Stores message for notification
  const [showNotification, setShowNotification] = useState(false); // Toggle notification visibility

  useEffect(() => {
    axios
      .get(`${BASE_URL}${PROVINCE_API}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setProvinces(response.data.data);
      })
      .catch((error) => console.error("Error fetching provinces:", error));
  }, [token]);

  const fetchCities = (provinceId) => {
    setCities([]);
    setAreas([]);
    axios
      .get(`${BASE_URL}${PROVINCE_API}/${provinceId}${CITY_API}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setCities(response.data.data);
      })
      .catch((error) => console.error("Error fetching cities:", error));
  };

  const fetchAreas = (cityId) => {
    setAreas([]);
    axios
      .get(`${BASE_URL}${PROVINCE_API}${CITY_API}/${cityId}${AREA_API}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setAreas(response.data.data);
      })
      .catch((error) => console.error("Error fetching areas:", error));
  };

  const handleAddNewAddress = async () => {
    setIsLoading(true);
    try {
      // Prepare new address data based on form input
      const newAddressData = {
        provinceId: Number(newAddress.province),
        cityId: Number(newAddress.city),
        areaId: Number(newAddress.area),
        detailAddress: newAddress.fullAddress,
        landmark: newAddress.landmark || "",
        phone: newAddress.phone,
        name: newAddress.fullName,
        isDefault: newAddress.isDefault === false,
        isHomeAddress: newAddress.type === "Home",
        // Send the typed value of the address here
      };

      // Send POST request to save the new address
      const response = await axios.post(
        `${BASE_URL}${ADDRESS_SAVE_API}`,
        newAddressData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 && response.data.code === 1) {
        setIsMessage(response.data.message); // Set the success message
        setShowNotification(true); // Show the notification
        setAddressData([...addressData, newAddressData]); // Update the address list with new data
      } else {
        throw new Error(response.data.message || "Failed to save address.");
      }
    } catch (error) {
      console.error("Error adding new address:", error);
      setIsMessage(error.message || "An unexpected error occurred.");
      setShowNotification(true); // Show the notification
    } finally {
      setIsLoading(false);
      setIsFormVisible(false); // Hide form after submission
    }
  };

  const handleUpdateAddress = async () => {
    setIsLoading(true);
    try {
      const updatedAddressData = {
        provinceId: Number(newAddress.province),
        cityId: Number(newAddress.city),
        areaId: Number(newAddress.area),
        detailAddress: newAddress.fullAddress,
        landmark: newAddress.landmark || "",
        phone: newAddress.phone,
        name: newAddress.fullName,
        isHomeAddress: newAddress.type === "Home",
        // Send the typed value of the address here
      };

      const response = await axios.put(
        `${BASE_URL}${ADDRESS_UPDATE_API}`,
        {
          id: currentAddressId,
          ...updatedAddressData,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 && response.data.code === 1) {
        setIsMessage(response.data.message); // Set the success message
        setShowNotification(true); // Show the notification
        setAddressData((prevData) =>
          prevData.map((item) =>
            item.id === currentAddressId
              ? { ...item, ...updatedAddressData }
              : item
          )
        );
      } else {
        throw new Error(response.data.message || "Failed to update address.");
      }
    } catch (error) {
      console.error("Error updating address:", error);
      setIsMessage(error.message || "An unexpected error occurred."); // Set the error message
      setShowNotification(true); // Show the notification
    } finally {
      setIsLoading(false);
      setIsFormVisible(false);
    }
  };

  const handleSelectedAddress = async (id) => {
    sessionStorage.setItem("addressId", id);
    try {
      const response = await axios.put(
        `${BASE_URL}${ADDRESS_UPDATE_API}/${id}${ADDRESS_SELECTED_API}`,
        { isDefault: true },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 200 && response.data.code === 1) {
        setIsMessage(response.data.message); // Set the success message
        setShowNotification(true); // Show the notification

        setAddressData((prevList) =>
          prevList.map((item) =>
            item.id === id
              ? { ...item, isDefault: true }
              : { ...item, isDefault: false }
          )
        );
      } else {
        throw new Error(response.data.message || "Failed to update address.");
      }
    } catch (error) {
      console.error("Error updating address:", error);
      setIsMessage(error.message || "An unexpected error occurred."); // Set the error message
      setShowNotification(true); // Show the notification
    }
  };

  const [addressData, setAddressData] = useState([]);
  useEffect(() => {
    if (!isLoading) {
      axios
        .get(`${BASE_URL}${ADDRESS_GET_API}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          setAddressData(response.data.data);
        })
        .catch((error) => console.error("Error fetching cities:", error));
    }
  }, [BASE_URL, ADDRESS_GET_API, token, isLoading]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewAddress({
      ...newAddress,
      [name]: value,
    });
  };

  const handleEditAddress = (id) => {
    setCurrentBtn(true);
    const addressToEdit = addressData.find((item) => item.id === id);

    if (addressToEdit) {
      setAddressData((prevData) =>
        prevData.map((item) =>
          item.id === id ? { ...item, ...addressData } : item
        )
      );
    }

    setCurrentAddressId(id);
    setIsFormVisible(true);

    axios
      .get(`${BASE_URL}${ADDRESS_GET_API}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const allAddresses = response.data.data;
        const addressToEdit = allAddresses.find((address) => address.id === id);

        if (addressToEdit) {
          setValue("fullName", addressToEdit.name || "");
          setValue("phone", addressToEdit.phone || "");
          setValue("province", addressToEdit.provinceId || "");
          setValue("city", addressToEdit.cityId || "");
          setValue("area", addressToEdit.areaId || "");
          setValue("type", addressToEdit.isHomeAddress ? "Home" : "Office");
          setValue("fullAddress", "");
        } else {
          console.error("Address not found!");
        }
      })
      .catch((error) => {
        console.error("Error fetching address details:", error);
        setIsMessage("Unable to fetch address details. Please try again."); // Error message
        setShowNotification(true); // Show notification
      });
  };

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      type: "Home",
      fullName: "",
      phone: "",
      fullAddress: "",
      area: "",
      city: "",
      province: "",
      country: "",
      postCode: "",
      landmark: "",
    },
  });

  const onSubmit = (data) => {
    if (currentBtn !== false) {
      handleUpdateAddress(data);
    } else {
      handleAddNewAddress(data);
    }
  };

  return (
    <section className="checkout">
      <Notification
        show={showNotification}
        type="success"
        message={isMessage}
        onClose={() => setShowNotification(false)}
      />
      <div className="container container-lg px-lg-5">
        <div className="row gy-4">
          <div
            className="col-xl-9 col-lg-8 py-10 px-24 "
            style={{
              borderRight: "0.1px solid var(--gray-100)",
            }}
          >
            <div className="mt-12 flex-between text-black">
              <p>Shipping & Billing</p>
              <button
                className="text-nowrap text-sm text-xs text-md-sm"
                style={{ color: "#194F7D" }}
                onClick={handleOpenDrawer}
              >
                EDIT
              </button>
              {/* Overlay Drawer */}
              <div
                className={`position-fixed top-0 end-0 w-100 h-100 bg-dark bg-opacity-75 z-2  ${
                  isDrawerOpen ? "open" : "closed"
                }`}
                onClick={handleOpenDrawer}
                style={{
                  transform: isDrawerOpen ? "scale(1,1)" : "scale(0,1)",
                }}
              ></div>
              {/* Shipping Drawer Start */}
              <div
                className="p-40 bg-white shadow-lg position-fixed  top-0 end-0  h-100 z-2"
                style={{
                  transform: isDrawerOpen ? "scale(1,1)" : "scale(0,1)",
                  transformOrigin: "right",
                  transition: "transform 0.3s ease-out",
                  width: "90%",
                }}
              >
                <div className="flex-between my-20 gap-20">
                  <p className="text-nowrap">Shipping Address</p>
                  <button
                    className="text-sm mt-4 text-primary text-nowrap"
                    onClick={() => {
                      setIsFormVisible(true);
                      setCurrentBtn(false);
                      reset();
                      setSelect(true);
                    }}
                  >
                    Add new address
                  </button>
                </div>
                <div className="cart-table text-capitalize">
                  {addressData.length === 0 ? (
                    <div className="empty-cart">
                      <h4>Please select an address!</h4>
                    </div>
                  ) : (
                    <div
                      className="overflow-x-auto"
                      style={{
                        display: "block",
                        overflowX: "auto",
                        whiteSpace: "nowrap",
                        maxHeight: "500px",
                      }}
                    >
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                        }}
                        className="table bg-color-three border-top-0 border-right-0 border-left-0"
                      >
                        <thead>
                          <tr>
                            <th className="bg-light text-xs"></th>
                            <th className="bg-light text-xs">Full Name</th>
                            <th className="bg-light text-xs"> Type</th>
                            <th className="bg-light text-xs">Address</th>
                            <th className="bg-light text-xs">Phone Number</th>
                            <th className="bg-light text-xs">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {addressData.map((item) => (
                            <tr
                              style={{ position: "relative", zIndex: 1 }}
                              key={item.id}
                              onClick={() => {
                                handleSelectedAddress(item.id);
                              }}
                            >
                              <td>
                                <img
                                  style={{ maxWidth: "20px" }}
                                  className="align-middle"
                                  src={
                                    item.isDefault
                                      ? "/assets/images/icon/tick.png"
                                      : "/assets/images/icon/untick.png"
                                  }
                                  alt=""
                                />
                              </td>
                              <td className="text-xs align-middle">
                                {item.name || ""}
                              </td>
                              <td className="text-xs align-middle">
                                <span
                                  className={`${
                                    item.isHomeAddress
                                      ? "bg-main-600"
                                      : "bg-primary"
                                  } mx-4 text-white px-10 py-4 rounded-20`}
                                >
                                  {item.isHomeAddress ? "Home" : "Office"}
                                </span>
                              </td>
                              <td className="text-xs align-middle">
                                {item.detailAddress}
                              </td>
                              <td className="text-xs align-middle">
                                +92{item.phone || "No phone number"}
                              </td>
                              <td
                                className="text-xs align-middle"
                                style={{
                                  position: "relative", // Adding relative positioning
                                  zIndex: 10, // Higher z-index than the row
                                }}
                              >
                                <button
                                  style={{
                                    position: "relative", // Adding relative positioning to the button
                                    zIndex: 20, // Higher z-index for the button
                                  }}
                                  className="text-primary"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleEditAddress(item.id);
                                    setSelect(false);
                                  }}
                                >
                                  EDIT
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
                <div className="d-flex justify-content-end mt-26 gap-24">
                  <button
                    className="text-muted bg-light p-10 px-14 rounded-6"
                    onClick={handleOpenDrawer}
                  >
                    CANCEL
                  </button>
                  <button
                    className="btn bg-primary text-muted"
                    onClick={() => {
                      handleOpenDrawer();
                    }}
                  >
                    SAVE
                  </button>
                </div>
              </div>
              {/* Shipping Drawer End */}
            </div>
            {/* form started */}
            {/* Form */}
            <>
              {isFormVisible && (
                <div>
                  <div
                    className="position-fixed top-0 start-0 w-100 h-100 z-3 bg-dark bg-opacity-75"
                    onClick={() => setIsFormVisible(false)}
                  ></div>
                  <div
                    className="form-container bg-white px-24 py-24 shadow-lg position-fixed top-50 start-50 translate-middle w-md-90 w-lg-auto z-3"
                    style={{
                      width: "90%",
                      height: "90vh",
                      maxWidth: "700px",
                      overflowY: "auto",
                    }}
                  >
                    <button
                      className="btn-close position-absolute top-0 end-0 m-24"
                      onClick={() => setIsFormVisible(false)}
                      aria-label="Close"
                    ></button>
                    <p className="text-lg text-black mb-4">
                      {currentAddressId !== null
                        ? "Edit Address"
                        : "Add New Shipping Address"}
                    </p>
                    <form onSubmit={handleSubmit(onSubmit)} className="row g-3">
                      {/* Full Name */}
                      <div className="col-12 col-md-6">
                        <label className="fw-light text-sm form-label">
                          Full Name
                        </label>
                        <Controller
                          name="fullName"
                          control={control}
                          rules={{ required: "Full Name is required" }}
                          render={({ field }) => (
                            <input
                              {...field}
                              onChange={(e) => {
                                field.onChange(e);
                                handleInputChange(e);
                              }}
                              className="text-sm fw-light form-control common-input rounded-0"
                              type="text"
                              placeholder="Enter your name"
                            />
                          )}
                        />

                        {errors.fullName && (
                          <p className="text-xs text-danger">
                            {errors.fullName.message}
                          </p>
                        )}
                      </div>

                      {/* Phone Number */}
                      <div className="col-12 col-md-6">
                        <label className="fw-light text-sm form-label">
                          Phone Number
                        </label>
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "4px",
                            position: "relative",
                          }}
                        >
                          {/* Country Code */}
                          <div
                            style={{
                              position: "absolute",
                              left: "10px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <span className="text-sm">+92</span>
                            <div
                              style={{
                                borderLeft: "1px solid var(--gray-100)",
                                height: "20px",
                                marginLeft: "8px",
                              }}
                            ></div>
                          </div>

                          {/* Phone Number Input */}
                          <Controller
                            name="phone"
                            control={control}
                            rules={{
                              required: "Phone number is required",
                              minLength: {
                                value: 10,
                                message: "Phone number must be 10 digits",
                              },
                              maxLength: {
                                value: 10,
                                message:
                                  "Phone number cannot be more than 10 digits",
                              },
                              pattern: {
                                value: /^3\d{9}$/, // Regex to ensure the number starts with 3
                                message: "Phone number must start with '3'",
                              },
                            }}
                            render={({ field }) => (
                              <input
                                {...field}
                                onChange={(e) => {
                                  field.onChange(e); // Notify React Hook Form about the change
                                  handleInputChange(e); // Execute any additional logic
                                }}
                                onInput={(e) => {
                                  // Enforce max length in real-time
                                  if (e.target.value.length > 10) {
                                    e.target.value = e.target.value.slice(
                                      0,
                                      10
                                    );
                                  }
                                }}
                                type="number"
                                className="common-input text-sm rounded-0"
                                placeholder="Enter your phone number"
                                style={{
                                  paddingLeft: "60px", // Accommodate the country code
                                  width: "100%", // Ensure the input takes up the full width
                                }}
                              />
                            )}
                          />
                        </div>

                        {/* Error message for phone */}
                        {errors.phone && (
                          <p className="text-xs text-danger">
                            {errors.phone.message}
                          </p>
                        )}
                      </div>

                      {/* Province Selector */}
                      <div className="col-12 col-md-6">
                        <label className="fw-light text-sm form-label">
                          Province
                        </label>
                        <Controller
                          name="province"
                          control={control}
                          rules={{ required: "Province is required" }}
                          render={({ field }) => (
                            <select
                              {...field}
                              onChange={(e) => {
                                field.onChange(e);
                                handleInputChange(e);
                                fetchCities(e.target.value);
                              }}
                              className="form-select common-input text-muted text-sm rounded-0 mt-2"
                            >
                              <option>Select Province</option>
                              {provinces.map((province) => (
                                <option key={province.id} value={province.id}>
                                  {province.name}
                                </option>
                              ))}
                            </select>
                          )}
                        />
                        {errors.province && (
                          <p className="text-xs text-danger">
                            {errors.province.message}
                          </p>
                        )}
                      </div>

                      {/* City Selector */}
                      <div className="col-12 col-md-6">
                        <label className="fw-light text-sm form-label">
                          City
                        </label>
                        <Controller
                          name="city"
                          control={control}
                          rules={{ required: "City is required" }}
                          render={({ field }) => (
                            <select
                              {...field}
                              onChange={(e) => {
                                field.onChange(e);
                                handleInputChange(e);
                                fetchAreas(e.target.value);
                              }}
                              className="form-select common-input text-muted text-sm rounded-0 mt-2"
                            >
                              <option>
                                {select == false
                                  ? addressData[0]?.cityName || "Select City"
                                  : "Select City"}
                              </option>
                              {cities.map((city) => (
                                <option key={city.id} value={city.id}>
                                  {city.name}
                                </option>
                              ))}
                            </select>
                          )}
                        />
                        {errors.city && (
                          <p className="text-xs text-danger">
                            {errors.city.message}
                          </p>
                        )}
                      </div>

                      {/* Area Selector */}
                      <div className="col-12 col-md-6">
                        <label className="fw-light text-sm form-label">
                          Area
                        </label>
                        <Controller
                          name="area"
                          control={control}
                          rules={{ required: "Area is required" }}
                          render={({ field }) => (
                            <select
                              {...field}
                              onChange={(e) => {
                                field.onChange(e);
                                handleInputChange(e);
                              }}
                              className="form-select common-input text-muted text-sm rounded-0 mt-2"
                            >
                              <option>
                                {select == false
                                  ? addressData[0]?.areaName || "Select Area"
                                  : "Select Area"}
                              </option>
                              {areas.map((area) => (
                                <option key={area.id} value={area.id}>
                                  {area.name}
                                </option>
                              ))}
                            </select>
                          )}
                        />
                        {errors.area && (
                          <p className="text-xs text-danger">
                            {errors.area.message}
                          </p>
                        )}
                      </div>

                      {/* Type Selector */}
                      <div className="col-12 col-md-6">
                        <label className="fw-light text-sm form-label">
                          Type
                        </label>
                        <Controller
                          name="type"
                          control={control}
                          rules={{ required: "Type is required" }}
                          render={({ field }) => (
                            <select
                              {...field}
                              onChange={(e) => {
                                field.onChange(e); // Required to update the form state
                                handleInputChange(e); // Custom function for extra logic
                              }}
                              className="form-select common-input text-muted text-sm rounded-0 mt-2"
                            >
                              <option value="Home">Home</option>
                              <option value="Office">Office</option>
                            </select>
                          )}
                        />
                        {errors.type && (
                          <p className="text-xs text-danger">
                            {errors.type.message}
                          </p>
                        )}
                      </div>

                      {/* Full Address */}
                      <div className="col-12 col-md-6">
                        <label className="fw-light text-sm form-label">
                          Full Address
                        </label>
                        <Controller
                          name="fullAddress"
                          value="fullAddress"
                          control={control}
                          rules={{ required: "Full Address is required" }}
                          render={({ field }) => (
                            <input
                              {...field}
                              onChange={(e) => {
                                field.onChange(e); // This updates the form state
                                handleInputChange(e); // Custom logic (optional)
                              }}
                              className="text-sm fw-light form-control common-input rounded-0"
                              type="text"
                              placeholder="Enter full Address"
                            />
                          )}
                        />

                        {errors.fullAddress && (
                          <p className="text-xs text-danger">
                            {errors.fullAddress.message}
                          </p>
                        )}
                      </div>

                      {/* Landmark */}
                      <div className="col-12 col-md-6">
                        <label className="fw-light text-sm form-label">
                          Landmark <span className="text-xs">(optional)</span>
                        </label>
                        <Controller
                          name="landmark"
                          control={control}
                          render={({ field }) => (
                            <input
                              {...field}
                              onChange={(e) => {
                                field.onChange(e);
                                handleInputChange(e);
                              }}
                              className="text-sm fw-light form-control common-input rounded-0"
                              type="text"
                              placeholder="Enter your landmark"
                            />
                          )}
                        />
                      </div>

                      {/* Submit Button */}
                      <div className="col-12">
                        {isLoading ? (
                          <BtnLoader />
                        ) : (
                          <button
                            type="submit"
                            className="btn rounded-0 text-xs btn-main my-8 w-100"
                          >
                            {currentBtn !== false
                              ? "Update Address"
                              : "Save Address"}
                          </button>
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              )}
            </>
            {/* divider */}
            <span className="mt-32 text-gray-900 border-top border-gray-100 d-block" />
            <div className="mt-32 text-black">
              <div className="flex-align gap-10">
                {/* Display Name and Phone */}
                <p className="text-capitalize">
                  {selectedId?.name || "No name provided"}
                </p>
                <p>
                  {selectedId?.phone
                    ? `+92${selectedId.phone}`
                    : "No phone number"}
                </p>
              </div>

              <div className="d-flex align-items-start gap-10 mt-20">
                {/* Display Address Details */}
                <p>
                  <span
                    className={`${
                      selectedId?.isHomeAddress ? "bg-main-600" : "bg-primary"
                    } mx-4 text-white px-10 py-4 rounded-20`}
                  >
                    {selectedId?.isHomeAddress ? "Home" : "Office"}
                  </span>
                  {selectedId?.detailAddress
                    ?.replace(/<br>/g, ", ")
                    ?.replace(",", "") || "No address provided"}
                  {selectedId?.city || "No city provided"},
                  {selectedId?.province || "No province provided"},
                </p>
              </div>

              {/* divider */}
              <span className="mt-32 text-gray-900 border-top border-gray-100 d-block" />
              <div className="mt-20">
                <p>Delivery options</p>
                <div className="d-block d-xl-flex gap-32">
                  {paymentMethods.map((method, index) => (
                    <div
                      key={index}
                      className={`tab-item border border-2 rounded-10 p-10 mt-12 ${
                        selectedMethod === method ? "border-primary" : ""
                      }`}
                      onClick={() => {
                        handleTabClick(method);
                        fetchSelectedOption(method.id);
                      }}
                      style={{
                        cursor: "pointer",
                        borderRadius: "5px",
                        backgroundColor:
                          selectedMethod === method ? "#f5f5f5" : "#fff",
                      }}
                    >
                      {/* Header Section */}
                      <div className="d-flex gap-10">
                        {/* Icon */}
                        <div
                          className="d-flex justify-content-center align-items-center rounded-circle"
                          style={{
                            width: "1.5rem",
                            height: "1.5rem",
                            border:
                              selectedMethod === method
                                ? "none"
                                : "2px solid #0d6efd", // Border when not selected
                            backgroundColor:
                              selectedMethod === method
                                ? "#0d6efd"
                                : "transparent", // Background when selected
                            color:
                              selectedMethod === method ? "#fff" : "#0d6efd", // Text color
                          }}
                        >
                          {selectedMethod === method && (
                            <i
                              className="bi bi-check"
                              style={{ fontSize: "1rem" }}
                            ></i>
                          )}
                        </div>

                        {/* Method Details */}
                        <div>
                          <p className="text-lg fw-medium mb-20">
                            {method.method}
                          </p>
                          <p>{method.infoDetails.point1}</p>
                        </div>
                      </div>

                      {/* Delivery Type */}
                      <div className="d-flex align-items-center gap-10 pt-4">
                        <i
                          className={`fas fa-check ${
                            method.method === "Express Delivery"
                              ? "text-success"
                              : "text-muted"
                          }`}
                          style={{ width: "1.5rem", height: "1.5rem" }}
                        ></i>
                        <p>{method.infoDetails.point2}</p>
                      </div>

                      {/* Additional Points */}
                      {["point3", "point4"].map((point, idx) => (
                        <div
                          key={idx}
                          className="d-flex align-items-center gap-10 pt-4"
                        >
                          <i
                            className="fas fa-check text-muted"
                            style={{ width: "1.5rem", height: "1.5rem" }}
                          ></i>
                          <p>{method.infoDetails[point]}</p>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-4 h-100 position-sticky top-0 bg-white">
            <div className="cart-sidebar py-20 px-10">
              <p className="text-lg text-muted mb-10">Promotion</p>
              <div className="mb-0 d-flex justify-content-center gap-3 align-items-center">
                <input
                  className=" form-control w-100 text-sm h-48 text-xs text-md-sm"
                  type="text"
                  placeholder="Enter Store/Lazmy Code"
                />
                <button
                  className="btn text-nowrap text-sm h-48 text-xs text-md-sm"
                  style={{ background: "#194F7D" }}
                >
                  Apply
                </button>
              </div>
              <div className="mt-32 p-0 ">
                <div className="mb-32 flex-between gap-8">
                  <span className="text-gray-900 text-xl font-heading-two">
                    Order Summary
                  </span>
                </div>
                {charges &&
                  Object.entries(charges).map(([title, value]) => {
                    if (title === "Total") return null; // Skip "Total" here; render separately if needed
                    return (
                      <div className="mb-32 flex-between gap-8" key={title}>
                        <span className="text-muted font-heading-two">
                          {title}
                        </span>
                        <span className="text-gray-900">
                          Rs. {value?.toFixed(2) || 0.0}
                        </span>
                      </div>
                    );
                  })}
                {/* divider */}
                <span className="mt-32 text-gray-900 border-top border-gray-100 d-block" />
              </div>
              <div className="mt-24">
                <div className="flex-between gap-8 w-100">
                  {charges &&
                    Object.entries(charges).map(([title, value]) => {
                      if (title === "Total")
                        return (
                          <div
                            className="mb-32 flex-between gap-8 w-100 text-xl fw-md"
                            key={title}
                          >
                            <span className="text-gray-900">{title}</span>
                            <span className="text-main">
                              Rs. {value?.toFixed(2) || 0.0}
                            </span>
                          </div>
                        );
                      return null;
                    })}
                </div>
              </div>
              <Link
                to="/payment"
                onClick={postplaceOrder}
                className="btn btn-main mt-40 py-18 w-100"
              >
                Proceed to Pay
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Checkout;
